import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 100;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (sectionId) => {
    // If we're not on the home page, navigate to home first
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
      // Use setTimeout to ensure navigation completes before scrolling
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // If we're already on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsOpen(false);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      scrolled ? 'bg-white/95 backdrop-blur-sm shadow-lg' : 'bg-white shadow-lg'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center">
              <Link to="/">
                <img className="h-10 w-auto" src="../../public/mtclicks.png" alt="MTClicks Logo" />
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-center space-x-4">
                <button
                  onClick={() => handleNavigation('home')}
                  className="text-gray-900 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors"
                >
                  Home
                </button>
                <button
                  onClick={() => handleNavigation('services')}
                  className="text-gray-500 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors"
                >
                  Services
                </button>
                <button
                  onClick={() => handleNavigation('solutions')}
                  className="text-gray-500 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors"
                >
                  Solutions
                </button>
                <button
                  onClick={() => handleNavigation('about')}
                  className="text-gray-500 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors"
                >
                  About
                </button>
                <button
                  onClick={() => handleNavigation('contact')}
                  className="text-gray-500 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors"
                >
                  Contact
                </button>
              </div>
            </div>
          </div>
          <button
            onClick={() => handleNavigation('contact')}
            className="hidden md:block bg-primary hover:bg-blue-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors"
          >
            Get Started
          </button>
          <div className="md:hidden">
            <button
              type="button"
              onClick={() => setIsOpen(!isOpen)}
              className="bg-gray-100 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
            >
              <i className={`fas ${isOpen ? 'fa-times' : 'fa-bars'}`}></i>
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile menu */}
      <div className={`md:hidden ${isOpen ? 'block' : 'hidden'}`}>
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
          <button
            onClick={() => handleNavigation('home')}
            className="text-gray-900 block px-3 py-2 rounded-md text-base font-medium w-full text-left"
          >
            Home
          </button>
          <button
            onClick={() => handleNavigation('services')}
            className="text-gray-500 hover:text-primary block px-3 py-2 rounded-md text-base font-medium w-full text-left"
          >
            Services
          </button>
          <button
            onClick={() => handleNavigation('solutions')}
            className="text-gray-500 hover:text-primary block px-3 py-2 rounded-md text-base font-medium w-full text-left"
          >
            Solutions
          </button>
          <button
            onClick={() => handleNavigation('about')}
            className="text-gray-500 hover:text-primary block px-3 py-2 rounded-md text-base font-medium w-full text-left"
          >
            About
          </button>
          <button
            onClick={() => handleNavigation('contact')}
            className="text-gray-500 hover:text-primary block px-3 py-2 rounded-md text-base font-medium w-full text-left"
          >
            Contact
          </button>
          <button
            onClick={() => handleNavigation('contact')}
            className="bg-primary hover:bg-blue-700 text-white block px-3 py-2 rounded-md text-base font-medium w-full text-center mt-2"
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
